import { render, staticRenderFns } from "./TabDynamic.vue?vue&type=template&id=17102c28"
import script from "./TabDynamic.vue?vue&type=script&lang=js"
export * from "./TabDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports